import React from 'react';
import '../estilo.css';

export default function Indicadores() {
  return (
    <div id="indicadores" className="container-fluid indicadores-section">
      <center>
        <h2 className="section-title">Quantum Trades EA – Inteligência Baseada em Indicadores Reais</h2>

        <img
          className="responsive-image indicador-main-img"
          src={require('../img/QuantumEA.png')}
          alt="Quantum Trades EA"
        />

        <h4 className="description">
          O <strong>Quantum Trades EA</strong> foi desenvolvido para oferecer alta flexibilidade.
          Ele utiliza mais de <strong>20 indicadores internos</strong> para montar estratégias automáticas
          robustas e personalizáveis.
          <br /><br />
          Todos os indicadores podem atuar como:
          <strong> Entrada | Saída | Filtro | Nenhum </strong>
        </h4>

        <h3 className="section-subtitle">Recursos Exclusivos do EA</h3>

        <div className="indicadores-feature-box">
          <p>
            ✔ Correlação direta e inversa entre qualquer ativo do MT5
            ✔ Filtros de Entrada/Saída combinando múltiplos indicadores
            ✔ Filtro de Notícias com bloqueio automático antes/depois de eventos
            ✔ Suporte a Reentradas, Gradiente, volumes variáveis e TPs individuais
            ✔ Suporte a múltiplos timeframes simultaneamente
            ✔ Sinais baseados em "Virada do Sinal" ou "Sempre que Possível"
          </p>
        </div>

        <h2 className="section-title">Indicadores com Visualização Integrada</h2>

        <div className="indicator">
          <img className="responsive-image" src={require('../img/Indicador_Agressao.png')} alt="Volume Agressão" />
          <h4>Volume de Agressão (Saldo de Contratos)</h4>
          <p className="indicator-text">
            Indicador proprietário QuantumTrades.
            Analisa saldo agressor comprador/vendedor e permite correlação entre qualquer ativo do MT5.
          </p>
        </div>

        <div className="indicator">
          <img className="responsive-image" src={require('../img/Indicador_Volume.png')} alt="Volume Negócios" />
          <h4>Volume de Negócios</h4>
          <p className="indicator-text">
            Mede volumes por períodos diferentes, permitindo detectar sequências crescentes de volume ou exaustão de mercado.
          </p>
        </div>

        <div className="indicator">
          <img className="responsive-image" src={require('../img/Media_ATR.png')} alt="Média ATR JMA" />
          <h4>Média ATR JMA</h4>
          <p className="indicator-text">
            Baseado em ATR para medir força, volatilidade e direção do preço.
          </p>
        </div>

        <div className="indicator">
          <img className="responsive-image" src={require('../img/Quantum_PTL.png')} alt="Quantum PTL" />
          <h4>Quantum PTL – Suporte e Resistência Dinâmicos</h4>
          <p className="indicator-text">
            Indicador proprietário baseado na detecção de micro suportes e resistências.
          </p>
        </div>

        <div className="indicator">
          <img className="responsive-image" src={require('../img/Indicador_Bars.png')} alt="Quantum Bars" />
          <h4>Quantum Bars – Força do Mercado</h4>
          <p className="indicator-text">
            Indicador proprietário que mede força através de OHLC, com múltiplos períodos
            simultâneos e filtros de candle mestre/escravo.
          </p>
        </div>

        <h2 className="section-title">Outros Indicadores Suportados pelo Quantum Trades EA</h2>

        <div className="indicator-list">
          <p>✔ Canal de Keltner</p>
          <p>✔ Bandas de Bollinger</p>
          <p>✔ Canal VWAP</p>
          <p>✔ Desvio da Média (Desvio Padrão)</p>
          <p>✔ IFR – Índice de Força Relativa</p>
          <p>✔ JMA – Indicador Proprietário QuantumTrades</p>
          <p>✔ Canal de 4 Médias</p>
          <p>✔ Rompimento de Preços e Percentual</p>
          <p>✔ Filtros de Média Móvel – Toque para iniciar/seguir operação</p>
          <p>✔ Saída por Média Móvel</p>
          <p>✔ Filtro de Notícias integrando calendário econômico</p>
        </div>

        <div className="indicadores-cta">
          <h3>Quer testar todos os indicadores na prática?</h3>
          <p>
            Crie sua conta, gere sua licença MT5 e comece a testar imediatamente.
          </p>
          <a href="/cadastro" className="btn btn-primary btn-lg">
            Criar Minha Conta
          </a>
        </div>
      </center>
    </div>
  );
}
